export enum KIND {
  positive = "positive",
  negative = "negative",
}
